export default __webpack_public_path__ + "static/media/metamask-logo.deb7de06.svg";